import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import SmoothScroll from "@/components/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function ProtectedRoute({ children }) {
    const { user, ready } = useAuth();
    if (!ready) {
        return (
            <div className="min-h-screen bg-abyss flex items-center justify-center">
                <span className="font-mono-tech text-xs uppercase tracking-[0.2em] text-steel">
                    Verifying access...
                </span>
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <SmoothScroll>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/admin/login" element={<Login />} />
                            <Route
                                path="/admin"
                                element={
                                    <ProtectedRoute>
                                        <Admin />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </SmoothScroll>
                </BrowserRouter>
                <Toaster position="top-right" />
            </AuthProvider>
        </div>
    );
}

export default App;
